import { Main } from './class/main-index.js';

var APP = new Main();
APP.init();

